module.exports = __webpack_public_path__ + "images/emoji/soon.79884ea6350a661da7dd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/soon.png
// module id = 0ABY
// module chunks = 1